import { FilterConfig } from 'SRC/fetch/api/observability';

export function checkIfValidFilter(item: FilterConfig) {
  const hasKey =
    !!item.cubejsKey || (item.cubejsKeys && item.cubejsKeys.length === 2);
  return !(!item.key || !item.name || !hasKey);
}
